import { parseDicom as p } from "dicom-parser";
import { extractImageFromCanvas as g } from "./files.js";
const o = {
  PATIENT_NAME: "x00100010",
  PATIENT_ID: "x00100020",
  PATIENT_DATE_OF_BIRTH: "x00100030",
  PATIENT_SEX: "x00100040",
  STUDY_INSTANCE_UID: "x0020000d",
  STUDY_ID: "x00200010",
  STUDY_DATE: "x00080020",
  STUDY_DESCRIPTION: "x00081030",
  MODALITY: "x00080060",
  BODY_PART: "x00180015",
  SERIES_INSTANCE_UID: "x0020000e",
  SERIES_NUMBER: "x00200011",
  SERIES_DATE: "x00080021",
  SERIES_DESCRIPTION: "x0008103e",
  INSTANCE_NUMBER: "x00200013",
  ROWS: "x00280010",
  COLUMNS: "x00280011",
  NUMBER_OF_FRAMES: "x00280008"
}, A = 1080;
function U(e) {
  return new Promise((s, t) => {
    const i = new FileReader();
    i.addEventListener("load", () => {
      const c = new Uint8Array(i.result), n = p(c), d = {
        patientName: n.string(o.PATIENT_NAME),
        patientId: n.string(o.PATIENT_ID),
        /** @see https://dicom.innolitics.com/ciods/rt-dose/patient/00100030 */
        patientDateOfBirth: (() => {
          const r = n.string(o.PATIENT_DATE_OF_BIRTH);
          return r == null ? null : r.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
        })(),
        /** @see https://dicom.innolitics.com/ciods/rt-dose/patient/00100040 */
        patientGender: (() => {
          const r = n.string(o.PATIENT_SEX);
          return r == null ? null : r === "M" ? "Male" : r === "F" ? "Female" : r === "O" ? "Other" : null;
        })(),
        studyInstanceUid: n.string(o.STUDY_INSTANCE_UID),
        studyId: n.string(o.STUDY_ID),
        studyDate: (() => {
          const r = n.string(o.STUDY_DATE);
          return r == null ? null : r.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
        })(),
        studyDescription: n.string(o.STUDY_DESCRIPTION),
        seriesInstanceUid: n.string(o.SERIES_INSTANCE_UID),
        seriesNumber: n.intString(o.SERIES_NUMBER),
        seriesDate: (() => {
          const r = n.string(o.SERIES_DATE);
          return r == null ? null : r.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
        })(),
        seriesDescription: n.string(o.SERIES_DESCRIPTION),
        modality: (() => {
          const r = n.string(o.MODALITY);
          return r == null ? null : f(r, {
            bodyPart: n.string(o.BODY_PART),
            procedure: n.string(o.STUDY_DESCRIPTION)
          });
        })(),
        instanceNumber: n.intString(o.INSTANCE_NUMBER),
        rows: n.int16(o.ROWS),
        columns: n.int16(o.COLUMNS),
        numberOfFrames: n.intString(o.NUMBER_OF_FRAMES)
      };
      s(d);
    }, { once: !0 }), i.addEventListener("error", (c) => {
      t(c);
    }, { once: !0 }), i.readAsArrayBuffer(e);
  });
}
const T = {
  MG: "mammogram",
  CT: "ct",
  MR: "mri",
  US: "ultrasound",
  ECG: "electrocardiogram",
  XA: "angiography",
  DX: "x-ray",
  CR: "x-ray",
  RG: "x-ray",
  IO: "x-ray",
  PX: "x-ray",
  ES: "others",
  OP: "ophthalmoscopy",
  OCT: "ophthalmoscopy",
  OT: "others"
}, _ = {
  BRONCH: "bronchoscopy",
  COLON: "colonoscopy",
  GASTRO: "gastroscopy"
};
function f(e, { bodyPart: a = "", procedure: s = "" }) {
  if (T[e]) {
    if (["DX", "CR", "RG", "IO", "PX"].includes(e) && a) {
      const t = a.toUpperCase();
      if (t.includes("CHEST")) return "chest x-ray";
      if (t.includes("LIMB") || t.includes("ARM") || t.includes("LEG")) return "limb x-ray";
      if (t.includes("SPINE")) return "spine x-ray";
    }
    if (e === "ES" && s) {
      const t = s.toUpperCase(), i = _[t];
      if (i != null) return i;
    }
    return T[e];
  }
  return "others";
}
async function M(e, a = A) {
  return window.cornerstoneWADOImageLoader.external.cornerstone = window.cornerstone, new Promise((s, t) => {
    const i = new FileReader();
    i.addEventListener("load", () => {
      const c = x(), n = i.result, { width: d, height: r } = C(n, a), u = O(d, r, c), E = window.cornerstoneWADOImageLoader.wadouri.fileManager.add(e);
      window.cornerstone.loadImage(E).then((l) => {
        const D = window.cornerstone.getDefaultViewportForImage(u, l);
        window.cornerstone.displayImage(u, l, D), setTimeout(() => {
          const S = g(u, e.name);
          I(), s(S);
        }, 2e3);
      }).catch((l) => {
        I(), t(l.error);
      });
      function I() {
        window.cornerstone.disable(u), c.removeChild(u), R(c);
        const l = parseInt(E.replace("dicomfile:", ""));
        window.cornerstoneWADOImageLoader.wadouri.fileManager.remove(l);
      }
    }, { once: !0 }), i.readAsArrayBuffer(e);
  });
}
function y() {
  const e = document.createElement("div");
  return e.id = "dicom-container", e.dataset.dicomContainer = !0, Object.assign(e.style, {
    position: "fixed",
    top: "-10000px",
    left: "-10000px",
    opacity: 0,
    pointerEvents: "none"
  }), document.body.appendChild(e), e;
}
let m = null;
const N = 5e3;
function R(e) {
  m = setTimeout(() => {
    if (m != null) {
      try {
        e.remove();
      } catch {
      }
      m = null;
    }
  }, N);
}
function x() {
  const e = document.querySelector("#dicom-container[data-dicom-container=true]");
  return e != null ? (clearTimeout(m), e) : y();
}
function C(e, a) {
  const s = new Uint8Array(e), t = p(s), i = t.int16("x00280010"), c = t.int16("x00280011"), n = c / i, d = Math.min(a, c), r = d / n;
  return {
    width: d,
    height: r
  };
}
function O(e, a, s) {
  const t = document.createElement("div");
  return t.classList.add("dicom-image-container"), t.style.width = `${e}px`, t.style.height = `${a}px`, s.appendChild(t), window.cornerstone.enable(t), t;
}
export {
  o as DicomTags,
  M as convertDicomToImageFile,
  U as getDicomMetadata
};
